import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import AddVectorIcon from "../../../src/assets/Icons/Add Vector.png";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import Pagination from "../common/Pagination";
import DetailModal from "../common/DetailModal";
import { CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";

const headerKeyMap = {
  Products: "products",
  Status: "orderStatus",
  "LMBP Id": "retailerId",
  "LMBP Name": "retailerName",
  "Consignee Name": "consigneeName",
  "Mobile No": "consigneeMobile",
  "Phone No": "consigneePhone",
  "Email Id": "consigneeEmailId",
  "Address Line 1": "consigneeAddress1",
  "Address Line 2": "consigneeAddress2",
  "Address Type": "addressType",
  Pincode: "consigneePincode",
  City: "consigneeCity",
  State: "consigneeState",
  Country: "consigneeCountry",
  "Invoice Number": "invoiceNumber",
  "Payment Mode": "paymentMode",
  "Express Type": "expressType",
  "Order Amount (₹)": "orderAmount",
  "COD Amount (₹)": "codAmount",
  "Shipment Weight": "shipmentWeight",
  "Shipment Length": "shipmentLength",
  "Shipment Width": "shipmentWidth",
  "Shipment Height": "shipmentHeight",
  "Pick Address ID": "pickAddressId",
  "Return Address ID": "returnAddressId",
  "Seller ID": "sellerId",
  "E-Way Bill Number": "ewaybillNumber",
  "Route Code": "routeCode",
  Carrier: "carrier",
  Response: "response",
  Waybill: "waybill",
};

const AddItemBagModal = ({
  show,
  handleClose,
  callApi,
  headers,
  data,
  totalRecords,
  pageSize,
  currentPage,
  setCurrentPage,
  loading,
  autoSelectAll = false,
  columnData,
  callTableApi,
  isViewMode = false,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [rowError, setRowError] = useState("");
  const [modalHeading, setModalHeading] = useState("");
  const [detailModal, setDetailModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [unselectedRows, setUnselectedRows] = useState([]);

  const handleBack = () => {
    handleClose();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    callApi(
      page,
      autoSelectAll ? "ItemsIncluded" : "addItem",
      autoSelectAll && columnData
    );
  };

  const showFullContent = (content, key) => {
    let heading = "Full Content";
    setModalHeading(heading);
    setModalText(content);
    setDetailModal(true);
  };

  const handleAddItemToBag = async (itemsIncluded) => {
    try {
      const payload = {
        username: loggedInUserName,
        bagNo: columnData?.bagNo,
      };

      if (autoSelectAll) {
        payload.removedItems = itemsIncluded;
      } else {
        payload.itemsIncluded = [
          ...columnData?.itemsIncludedIds,
          ...itemsIncluded,
        ];
      }

      let apiUrl = "";
      if (autoSelectAll) {
        apiUrl = apiList.REMOVE_ITEMS_BAG_MASTER;
      } else {
        apiUrl = apiList.ADD_ITEMS_BAG_MASTER;
      }

      const response = await axiosPostApi(apiUrl, payload);
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
          allowOutsideClick: false,
        });
        callTableApi(1);
        handleClose();
      } else if (response?.status === 200 && !response?.data?.status) {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error("Error processing request:", error);
      CustomAlert({
        title: "Error",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleBagSeal = async () => {
    try {
      const payload = {
        username: loggedInUserName,
        bagNo: columnData?.bagNo,
      };

      const response = await axiosPostApi(apiList.BAG_SEAL, payload);
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
          allowOutsideClick: false,
        });
        callTableApi(1);
        handleClose();
      } else if (response?.status === 200 && !response?.data?.status) {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error("Error processing request:", error);
      CustomAlert({
        title: "Error",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleSuccess = () => {
    const itemsIncluded = autoSelectAll ? unselectedRows : selectedRows;
    handleAddItemToBag(itemsIncluded);
  };

  useEffect(() => {
    if (show && data?.length > 0 && autoSelectAll) {
      const currentPageIds = data.map((row) => row.id);

      // Only add new IDs that were not previously selected
      setSelectedRows((prev) => [
        ...prev,
        ...currentPageIds.filter((id) => !prev.includes(id)),
      ]);

      // Do NOT remove anything from unselectedRows here!
    }
  }, [show, data, autoSelectAll]);

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content w-[90vw] h-[90vh] custom-scrollbar rounded-3xl p-6 bg-white border border-gray-200">
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between border-b-0 mb-3">
                <div className="flex items-center">
                  <img
                    src={AddVectorIcon}
                    alt="Add Icon"
                    className="w-[43px] h-[38px] mr-2"
                  />
                  <h5 className="modal-title main-title font-medium text-lg">
                    {isViewMode ? "View" : "Select"}
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                {loading ? (
                  <div className="!w-[87vw] h-[61vh] flex items-center justify-center">
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    <div className="modal-body space-y-4">
                      {/* TABLE UI */}
                      <div className="!overflow-auto !w-[87vw] h-[61vh] custom-scrollbar">
                        <table className="table">
                          <thead>
                            <tr>
                              <th className="!bg-[#ffe8d4]"></th>{" "}
                              {headers.map((header, index) => (
                                <th key={index} className="!bg-[#ffe8d4]">
                                  {header}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data && data?.length > 0 ? (
                              data.map((row, index) => {
                                // const currentCode = row.id;
                                const rowId = row.id;
                                const isChecked =
                                  selectedRows.includes(rowId) &&
                                  !unselectedRows.includes(rowId);

                                return (
                                  <React.Fragment key={index}>
                                    <tr>
                                      <td className="text-center">
                                        <input
                                          type="checkbox"
                                          name="selectRow"
                                          checked={isChecked}
                                          className="cursor-pointer"
                                          onChange={() => {
                                            if (isChecked) {
                                              // currently checked → uncheck it
                                              setUnselectedRows((prev) => [
                                                ...prev,
                                                rowId,
                                              ]);
                                            } else {
                                              // currently unchecked → check it
                                              setUnselectedRows((prev) =>
                                                prev.filter(
                                                  (id) => id !== rowId
                                                )
                                              );
                                            }

                                            // Ensure selectedRows always contains all rows that are not unselected
                                            setSelectedRows((prev) => {
                                              if (isChecked) {
                                                return prev.filter(
                                                  (id) => id !== rowId
                                                );
                                              } else {
                                                return prev.includes(rowId)
                                                  ? prev
                                                  : [...prev, rowId];
                                              }
                                            });
                                          }}
                                          disabled={
                                            columnData?.status === "SEALED" ||
                                            isViewMode
                                          }
                                        />
                                      </td>

                                      {headers.map((header, i) => {
                                        const key = headerKeyMap[header];
                                        const value = row[key];

                                        return (
                                          <td key={i}>
                                            {(key === "response" ||
                                              key === "consigneeAddress1" ||
                                              key === "consigneeAddress2") &&
                                            value ? (
                                              <>
                                                {value.substring(0, 8)}...
                                                <div
                                                  className="text-[#FF702B] underline cursor-pointer"
                                                  title="View full content"
                                                  onClick={() =>
                                                    showFullContent(value, key)
                                                  }
                                                >
                                                  View More
                                                </div>
                                              </>
                                            ) : Array.isArray(value) ? (
                                              value
                                                .map((v) => v.productName)
                                                .join(", ")
                                            ) : (
                                              value ?? "-"
                                            )}
                                          </td>
                                        );
                                      })}
                                    </tr>

                                    {rowError && isChecked && (
                                      <tr>
                                        <td colSpan={headers.length + 1}>
                                          <div
                                            className="alert alert-danger text-start"
                                            role="alert"
                                            style={{ margin: 0 }}
                                          >
                                            {rowError}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={headers.length + 1}>
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION */}
                      {totalRecords > pageSize && (
                        <div className="flex justify-center mt-3">
                          <Pagination
                            currentPage={currentPage}
                            totalCount={totalRecords}
                            pageSize={pageSize}
                            onPageChange={handlePageChange}
                          />
                        </div>
                      )}

                      <DetailModal
                        open={detailModal}
                        onClose={() => setDetailModal(false)}
                        text={modalText}
                        headingText={modalHeading || "Details"}
                      />
                    </div>
                    <div
                      className={`flex justify-center gap-4 border-t-0 ${
                        totalRecords > pageSize ? "" : "pt-3"
                      }`}
                    >
                      <button
                        type="button"
                        className="btn btn-back w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                        onClick={handleBack}
                      >
                        {isViewMode ? "Close" : "Back"}
                      </button>
                      {!isViewMode && (
                        <>
                          <button
                            type="button"
                            className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                            onClick={handleSuccess}
                            disabled={columnData?.status === "SEALED"}
                          >
                            {autoSelectAll ? "Remove" : "Submit"}
                          </button>
                          {autoSelectAll && (
                            <button
                              type="button"
                              className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                              onClick={handleBagSeal}
                              disabled={columnData?.status === "SEALED"}
                            >
                              Seal
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddItemBagModal;
